import { Controller } from "@hotwired/stimulus"
import { ExaminationPreferenceService } from "../services/examination_preference_service"

// Connects to data-controller="transcript-selector"
export default class extends Controller {
  static targets = ["select"]
  static outlets = ["audio-recording", "soniox-recording"]

  async change() {
    const isVisible = this.selectTarget.value === "true"

    try {
      // ExaminationPreferenceを更新
      await ExaminationPreferenceService.updateShowTranscript(isVisible)

      // 文字起こしエリアの表示/非表示を切り替え
      this.updateTranscriptAreaVisibility(isVisible)

    } catch (error) {
      console.error('設定の保存に失敗しました:', error)
      // エラー時は元の状態に戻す
      this.selectTarget.value = isVisible ? "true" : "false"
      alert('設定の保存に失敗しました。')
    }
  }

  updateTranscriptAreaVisibility(isVisible) {
    // Stimulus Outletsを使って他のコントローラーのメソッドを呼び出し
    // AmiVoice (audio-recording) / Soniox (soniox-recording) のどちらが接続されていても動くようにする
    if (this.hasAudioRecordingOutlet) {
      this.audioRecordingOutlet.updateTranscriptVisibility(isVisible)
    }
    if (this.hasSonioxRecordingOutlet) {
      this.sonioxRecordingOutlet.updateTranscriptVisibility(isVisible)
    }
  }
}